<app-uni-page [parent]="this" *ngIf="isPageReady" pageTitle="Issues" [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>

  <app-ag-grid [gridOptions]="eiGridOptions" [rowData]="entityIssues"></app-ag-grid>


</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" (click)="removeIssues()">Remove Selected Issues</button>
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>